'use client'
import LayoutModal, { LayoutModalProps } from '@components/popup/layout-modal'

import Form from './form'

import styles from './search.module.scss'

import type { JSX } from 'react'

export default function Search({ isOpen, close }: Omit<LayoutModalProps, 'children' | 'title'>): JSX.Element {
  return (
    <LayoutModal
      isOpen={isOpen}
      close={close}
      title={<h2 className={styles.title} dangerouslySetInnerHTML={{ __html: 'Search over <span>1M jobs</span>' }} />}
    >
      <h3 className={styles.subtitle}>The US’s top jobs. All in one place.</h3>
      <Form close={close} />
    </LayoutModal>
  )
}
